import { ComputedTeam } from "shared/helpers/types/computed/ComputedTeam";
import { FC, useMemo } from 'react';
import {Colors, FlexBox} from "@brg/ui";
import {TFile} from "@brg/api";
import styled from "styled-components";
import { LayoutConst } from 'core';
import { useTranslation } from "react-i18next";
import { CoverType, getChannelColor } from "shared/pages/teams/components/support/getChannelColor";
import { ModerationType } from "shared/pages/teams/const/ModerationTypes";

const HolderWrapper = styled(FlexBox)<{ bg: string }>`
    width: 100%;
    height: 100%;
    justify-content: center;
    place-items: center;
    font-size: 280px;
    line-height: 224px;
    background-color: ${({ bg }) => bg || Colors.galBlack47};
    color: #fff;

    @media(max-width: ${LayoutConst.screen.md}px) {
        font-size: 34px;
    }
`;

export const TeamHolder: FC<{ team: ComputedTeam, files?: TFile[] }> = ({ team, files }) => {
    const { i18n: {language}} = useTranslation();

    const getFirstLetter = (value: unknown): string => {
        if (typeof value === 'string') {
            const trimmedValue = value.trim();
            return trimmedValue.charAt(0) || '';
        }

        return '';
    };

    const getFirstTeamNameLetter = (team: { name?: string }): string =>
        team?.name?.trim().charAt(0) ?? '';

    const owner = useMemo(() => {
        return team && team?.owners?.[0]
    } , [team])

    const ownerFirstLetterName = useMemo(() => {
        if (owner && typeof owner?.name === 'string') {
            return getFirstLetter(owner?.name)
        }
        return ''
    } , [owner])

    const teamNameFirstLetter = useMemo(() => {
        return getFirstTeamNameLetter(team)
    }, [team, language])

    const holder = useMemo(() => {
        return `${ownerFirstLetterName || teamNameFirstLetter}`.toUpperCase()
    }, [ownerFirstLetterName, teamNameFirstLetter])

    const coverBg = useMemo(() => {
        const type = team?.moderationType === ModerationType.Outer 
        ? CoverType.AUTHOR 
        : CoverType.DEFAULT
        return getChannelColor(type)
    } , [team]) as string

    return <HolderWrapper bg={coverBg} >{holder}</HolderWrapper>
}import { ComputedTeam } from "shared/helpers/types/computed/ComputedTeam";
import { FC, useMemo } from 'react';
import {Colors, FlexBox} from "@brg/ui";
import {TFile} from "@brg/api";
import styled from "styled-components";
import { LayoutConst } from 'core';
import { useTranslation } from "react-i18next";
import { CoverType, getChannelColor } from "shared/pages/teams/components/support/getChannelColor";
import { ModerationType } from "shared/pages/teams/const/ModerationTypes";

const HolderWrapper = styled(FlexBox)<{ bg: string }>`
    width: 100%;
    height: 100%;
    justify-content: center;
    place-items: center;
    font-size: 280px;
    line-height: 224px;
    background-color: ${({ bg }) => bg || Colors.galBlack47};
    color: #fff;

    @media(max-width: ${LayoutConst.screen.md}px) {
        font-size: 34px;
    }
`;

export const TeamHolder: FC<{ team: ComputedTeam, files?: TFile[] }> = ({ team, files }) => {
    const { i18n: {language}} = useTranslation();

    const getFirstLetter = (value: unknown): string => {
        if (typeof value === 'string') {
            const trimmedValue = value.trim();
            return trimmedValue.charAt(0) || '';
        }

        return '';
    };

    const getFirstTeamNameLetter = (team: { name?: string }): string =>
        team?.name?.trim().charAt(0) ?? '';

    const owner = useMemo(() => {
        return team && team?.owners?.[0]
    } , [team])

    const ownerFirstLetterName = useMemo(() => {
        if (owner && typeof owner?.name === 'string') {
            return getFirstLetter(owner?.name)
        }
        return ''
    } , [owner])

    const teamNameFirstLetter = useMemo(() => {
        return getFirstTeamNameLetter(team)
    }, [team, language])

    const holder = useMemo(() => {
        return `${ownerFirstLetterName || teamNameFirstLetter}`.toUpperCase()
    }, [ownerFirstLetterName, teamNameFirstLetter])

    const coverBg = useMemo(() => {
        const type = team?.moderationType === ModerationType.Outer 
        ? CoverType.AUTHOR 
        : CoverType.DEFAULT
        return getChannelColor(type)
    } , [team]) as string

    return <HolderWrapper bg={coverBg} >{holder}</HolderWrapper>
}